<template>
  <layout>
    <template v-slot:header>
      <global-navigation></global-navigation>
    </template>

    <main v-if="hasPage" class="Page">
      <h1 class="wcag-hidden">About</h1>

      <paw v-if="isNotFound" />
      <figure v-if="page.videofile" class="header">
        <video :src="page.videofile" autoplay loop muted playsinline />
      </figure>
      <figure v-else-if="page.featuredimage && page.featuredimage.large" class="header">
        <img :src="page.featuredimage.large" alt="" />
      </figure>
      <section>
        <rich-text :class="['content', { 'not-found': isNotFound }]" :content="page.text" />
      </section>
      <section>
        <rich-text :class="['content', { 'not-found': isNotFound }]" :content="page.otherinfo" />
      </section>
    </main>

    <template v-slot:footer>
      <global-footer :border="hasBorder"></global-footer>
    </template>
  </layout>
</template>

<script>
import PageMixin from '@/mixins/PageMixin'
import RichText from '@/components/RichText'
import Paw from '@/components/Paw'

export default {
  name: 'About',
  mixins: [PageMixin],
  components: { RichText, Paw },
  computed: {
    hasBorder() {
      return this.hasPage && (!!this.page.videofile || !!(this.page.featuredimage && this.page.featuredimage.large))
    },
  },
}
</script>

<style scoped>
.header {
  border-radius: var(--br);
  position: relative;
  margin: 0 2rem;
  width: calc(100% - 4rem);
  max-height: calc(100vh - 12rem);
  overflow: hidden;
}

.header:before {
  content: '';
  display: block;
  padding-bottom: 56.25%;
}

.header > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.not-found {
  text-align: center;
  font: var(--nord);
  text-transform: uppercase;
}

.content {
  padding: 4rem 19% 6rem 19%;
}

@media (max-width: 1360px) {
  .content {
    padding: 4rem 20%;
  }
}

@media (max-width: 1000px) {
  .content {
    padding: 4rem 2rem;
  }
}
</style>
